module.exports = __webpack_public_path__ + "img/text-con-4.0ab3f99c.png";